/**
 *
 * Asynchronously loads the component for ClientInvite
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ClientInvite = lazyLoad(
  () => import('./index'),
  module => module.ClientInvite,
);
